module.exports = __webpack_public_path__ + "static/landing-bg-df8fd3efcd662b64b44de07f351c838b.jpg";